module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexRow"
  }, [_vm._m(0), _vm._v(" "), (_vm.firebaseAuthInitialized) ? _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n    Login\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/icons/block-logo-bw-256.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-485542b4!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/LoginView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-485542b4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/LoginView.vue
// module chunks = 0